import { useContext } from 'react'
import Select from '../../components/selects/Select'
import MastContext, { Sensors } from '../../contexts/MastContext'

const SelectSensors = ({
  sensor,
  setSensor,
}: {
  sensor: Sensors
  setSensor: (sensor: Sensors) => void
}) => {
  const { sensors, sensorsIsLoading } = useContext(MastContext)

  return (
    <Select<Sensors>
      itemKeyName='id'
      itemValueName='label'
      selected={sensor}
      items={sensors}
      onChange={setSensor}
      isLoading={sensorsIsLoading}
    />
  )
}

export default SelectSensors
